export default __webpack_public_path__ + "img/b825621dc1d3bfd3a83d306f348bdd7b.png";